const accountI18n = require('./account')
module.exports = {
  ...accountI18n,
  store: 'ហាង',
  storeStatus: 'ស្ថានភាពហាង',
  merchant: 'ម្ចាស់ហាង',
  storeManager: 'ការគ្រប់គ្រងហាង',
  businessManager: 'ការគ្រប់គ្រងអាជីវកម្ម',
  imageManager: 'រូបភាព',
  infoManager: 'ព័ត៌មាន',
  financeManager: 'ព័ត៌មានហិរញ្ញវត្ថុ',
  orderManager: 'ការគ្រប់គ្រងការបញ្ជាទិញ',
  addExtraTime: 'បន្ថែមពេលវេលាបន្ថែម',
  historyOrder: 'ប្រវត្តិសាស្ត្របញ្ជាទិញ',
  allOrder: 'ការបញ្ជាទិញទាំងអស់',
  preOrder: 'ការបញ្ជាទិញថ្មី',
  appointmentOrder: 'បុងកក់ទុក',
  mealPreOrder: 'កំពុងរៀបចំ',
  mealFinish: 'រៀបចំរួចរាល់',
  refundOrder: 'លុបបញ្ជាទិញ/បង្វិលសងប្រាក់',
  itemManager: 'ការគ្រប់គ្រងទំនិញ',
  classfication: 'តារាប្រភេទ',
  itemList: 'តារាងទំនិញ',
  open: 'បើកលក់',
  rest: 'សម្រាក',
  pushMessage: 'បញ្ជូនព័ត៌មាន',
  labelOptions: 'ជម្រើសស្លាក',
  labelCloseOther: 'បិទផ្សេងទៀត',
  labelCloseAll: 'បិទទាំងអស់',
  openShop: 'បានបើក',
  notSupport: 'មិនគាំទ្រ',
  within1: 'ក្នុងថ្ងៃតែមួយ',
  within2: 'ក្នុងរយៈពេល 2 ថ្ងៃ',
  within3: 'ក្នុងរយៈពេល 3 ថ្ងៃ',
  within4: 'ក្នុងរយៈពេល 4 ថ្ងៃ',
  within5: 'ក្នុងរយៈពេល 5 ថ្ងៃ',
  merchantName: 'ឈ្មោះហាង',
  showMap: 'ឆែកផែនទី',
  menuSetting: 'ការកំណត់ម៉ឺនុយ',
  addMenu: 'បន្ថែមម៉ឺនុយ',
  storeName: 'ឈ្មោះហាង',
  contactName: 'ឈ្មោះទំនាក់ទំនង',
  contactTel: 'លេខទំនាក់ទំនង',
  ownedCity: 'ទីក្រុង',
  coordinate: 'កូអរដោនេហាង',
  longitude: 'ខ្សែស្រប',
  latitude: 'ខ្សែទទឹង',
  storeAddress: 'អាស័យដ្ឋានហាង',
  plan: 'បង្ហាញ',
  envPhoto: 'ផែនទីបរិស្ថានហាង',
  openDate: 'ពេលវេលាអាជីវកម្ម',
  businessStatus: 'ស្ថានអាជីវកម្ម',
  businessDay: 'ថ្ងៃធ្វើអាជិវកម្ម',
  businessTime: 'ម៉ោងធ្វើអាជីវកម្ម',
  paymentMethod: 'វិធីទូទាត់ប្រាក់',
  mainBusiness: 'អាជីវកម្មចម្បង',
  businessRange: 'បរិវេណអាជីវកម្ម',
  businessType: 'ប្រភេទអាជីវកម្ម',
  preMealTime: 'ពេលវេលារៀបចំអាហារ',
  valueAddTax: 'អត្រាពន្ធបន្ថែម',
  bookingTime: 'កំណត់ពេលវេលាបញ្ជាទិញ',
  startPrice: 'តម្លៃចាប់ផ្តើម',
  speedService: 'សេវារហ័ស',
  basicTime: 'មូលដ្ឋាននៃពេលវេលារៀបចំអាហារ',
  bigTime: 'ពពេលវេលារៀបចំអាហារចំនួនច្រើន',
  useActuallyPay: 'ពេលអតិថិជនទូទាត់ប្រាក់',
  hour: '$',
  openExpress: 'បើក',
  closeExpress: 'បិទ',
  today: 'សព្វថ្ងៃ',
  tomorrow: 'ថ្ងៃស្អែក',
  asOf: 'រហូតដល់',
  newStoreLabel: 'ស្លាកហាងថ្មី',
  newStore: 'ហាងថ្មី',
  noNewStore: 'ហាងមិនមែនថ្មី',
  switchBusinessStatus: 'ប្តូរស្ថានភាពអាជីវកម្មទៅជាបិទ,តើអ្នកយល់ព្រមទេ?',
  sureOpenBusiness: 'តើអ្នកយល់ព្រមបើកអាជីវកម្មឬទេ? លោកអ្នកមិនអាចកែប្រែបន្ទាប់ពីបើកអាជីវកម្មរួច!',
  accountName: 'ឈ្មោះគណនី',
  accountBank: 'គណនីធនាគារ',
  bankAccount: 'លេខគណនី',
  serviceCalc: 'វិធីគណនាថ្លៃសេវាកម្ម',
  serviceRate: 'អត្រាសេវាកម្ម',
  minAmount: 'ចំនួនទឹកប្រាក់ដកតិចបំផុត',
  remainingBalance: 'ចំនួនទឹកប្រាក់នៅសល់',
  WithdrawalMethod: 'វិធីស្នើសុំការដកប្រាក់',
  startDate: 'ពេលវេលាចាប់ផ្ដើម',
  withdrawalCycle: 'វដ្តដកប្រាក់',
  day: 'ថ្ងៃ',
  handApplyWithdrawal: 'ស្នើសុំការដកប្រាក់ដោយផ្ទាល់',
  autoApplayWithdrawal: 'ស្នើសុំការដកប្រាក់ដោយស្វ័យប្រវត្តិ',
  nextWithdrawal: 'កាលបរិច្ឆេទដកប្រាក់លើកក្រោយដោយស្វ័យប្រវត្តិ',
  noHandApplyWithdrawal: 'មិនអាចដំណើរការស្នើសុំការដកប្រាក់ដោយផ្ទាល់',
  deleteCategory: 'ប្រតិបត្តិការនេះនឹងលុបប្រភេទមួយនេះជារៀងរហូត តើអ្នកចង់បន្តឬទេ?',
  autoRest: 'នឹងឈប់សំរាកដោយស្វ័យប្រវត្តិនៅ{args}',
  autoBusiness: 'នឹងបើកអាជីវកម្មដោយស្វ័យប្រវត្តិនៅ{args}',
  noAuto: 'នឹងមិនបើក / បិទអាជីវកម្មដោយស្វ័យប្រវត្តិទេ ត្រូវការបើក / បិទដោយផ្ទាល់ដៃ',
  search_map: 'បញ្ចូលសំណួរអាសយដ្ឋាន',
  storeClosed: 'ហាងត្រូវបានបិទ',
  storeStopTime: 'ផ្អាកជំនួញផែនការ',
  endTimeShouldNotGtStartTime: 'ពេលវេលាចាប់ផ្តើមមិនអាចធំជាងម៉ោងបញ្ចប់បានទេ។',
  maxsixtyDay: 'ចន្លោះពេលអតិបរមាសម្រាប់ការផ្អាកអាជីវកម្មអាចត្រូវបានកំណត់ទៅ 60 ថ្ងៃ។',
  stopStoreBusiness: 'ហាងនេះត្រូវបានបិទជាបណ្តោះអាសន្ន។ ការប្តូរស្ថានភាពនៅពេលនេះនឹងបោះបង់គម្រោងការផ្អាកហាង។',
  startTimeLimit: 'ពេលវេលាចាប់ផ្តើមមិនត្រូវតិចជាងម៉ោងបច្ចុប្បន្នទេ។',
  businessTimeLimit: 'ពេលវេលាចាប់ផ្តើមអាជីវកម្ម និងពេលវេលាបញ្ចប់អាជីវកម្មមិនអាចដូចគ្នាបានទេ។',
  vatCaclMethod: 'វិធីសាស្រ្តគណនា VAT',
  packageAmount: 'ថ្លៃវេចខ្ចប់',
  packageAmountTips: 'ការកំណត់ថ្លៃកញ្ចប់នឹងប៉ះពាល់ដល់ការបញ្ជាទិញរបស់អ្នកប្រើប្រាស់',
  caclByMainScope: 'ការគណនាតាមអាជីវកម្មចម្បងរបស់ហាង។',
  editMenu: 'កែម៉ឺនុយ',
  editStock: 'កែស្តុក',
  stockMust: 'ស្តុកត្រូវតែ >=0',
  stockMax: 'មិនអាចលើសពីស្តុកអតិបរមាទេ',
  intCheck: 'សូមបញ្ចូលចំនួនគត់',
  noMenu: 'គ្មានម៉ឺនុយ',
  CalculatedMethod: 'Calculated as [Item Original Price + Packaging Fee + VAT]',
  announcement: 'សេចក្តីប្រកាស',
  announcementTime: 'សេចក្តីប្រកាសអំពីពេលវេលាបញ្ចប់',
  largePrepareTimeTip: "គ្រប់ ${x} ត្រូវរង់ចាំ​",
  maxMealTimeTip:"// តំលៃបុង>= ​${maxmoney} ពេលវេលា，នឹងប្រើពេលវេលាអតិបរមាររៀបចំអាហារ",
  factor: 'ចំនួន',
  maxPrepareTime: 'ពេលវេលារៀបចំអាហារអតិបរមា​',
  submitFail:'ការដាក់ស្នើបានបរាជ័យ។',
  submitFailTip:'ដៃរគូសហការរបស់ក្រុមហ៊ុនដឹកជញ្ជូនអាហារ WOWNOW ជាទីគោរព ក្នុងរយៈពេលថ្មីៗនេះប្រព័ន្ធបានរកឃើញស្ថានភាពអាជីវកម្មហាងមិនប្រក្រតី បានបិទហាងដោយស្វ័យប្រវត្តិ ប្រសិនបើអ្នកត្រូវការបន្តអាជីវកម្ម សូមទាក់ទងអ្នកប្រឹក្សាវេទិកា',
  tooShortBusinessHourTitle: 'ម៉ោងដំណើរការបើកហាងខ្លីពេក',
  tooShortBusinessHourTip: 'ការដាក់ម៉ោងដំណើរការហាងខ្លីពេក តើលោកអ្នកចង់បន្តដាក់ស្នើឬទេ?'
}
